import {useEffect, useState} from 'react';

import {urlPrefixed} from '../forgeApi';

export const calculateTtl = (timestamp: string): string => {
  const currentTime = new Date().getTime();
  const roleTime = new Date(timestamp).getTime();

  if (Number.isNaN(roleTime)) {
    return '';
  }

  const ttl = roleTime - currentTime;

  if (ttl <= 0) {
    return '';
  }

  const hours = Math.floor(ttl / (1000 * 60 * 60));
  const minutes = Math.floor((ttl % (1000 * 60 * 60)) / (1000 * 60));

  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  }
  return `${minutes}m`;
};

export type TeleportAccessRequests = {
  approvedTeleportAccessRequests: Record<string, string>;
  isFetching: boolean;
};

export function useTeleportAccessRequests(
  isWbAdmin: boolean
): TeleportAccessRequests {
  const [requestState, setRequestState] = useState(() => ({
    approvedTeleportAccessRequests: {} as Record<string, string>,
    isFetching: isWbAdmin,
    isWbAdmin,
  }));
  const stateMatchesViewer = requestState.isWbAdmin === isWbAdmin;

  useEffect(() => {
    let isCancelled = false;

    if (!isWbAdmin) {
      return () => {
        isCancelled = true;
      };
    }

    fetch(urlPrefixed('/teleport/access_requests'), {
      method: 'GET',
      credentials: 'include',
    })
      .then(async response => {
        if (!response.ok) {
          throw new Error(
            `Teleport access request fetch failed: ${response.status}`
          );
        }
        const data: Record<string, string> = await response.json();
        if (!isCancelled) {
          setRequestState({
            approvedTeleportAccessRequests: data,
            isFetching: false,
            isWbAdmin,
          });
        }
      })
      .catch(() => {
        if (!isCancelled) {
          setRequestState({
            approvedTeleportAccessRequests: {},
            isFetching: false,
            isWbAdmin,
          });
        }
      });

    return () => {
      isCancelled = true;
    };
  }, [isWbAdmin]);

  return {
    approvedTeleportAccessRequests: stateMatchesViewer
      ? requestState.approvedTeleportAccessRequests
      : {},
    isFetching: isWbAdmin && (!stateMatchesViewer || requestState.isFetching),
  };
}
